import $ from 'jquery';
import ReadingPositionIndicator from '../vendor/rpi/rpi.js';

const $wrapper = $( '.js-reading-wrapper' );

if ( $wrapper.length ) {
	setTimeout( function waitUntilDomIsReadyLoadingCustomFontsMightOffsetThis() {
		new ReadingPositionIndicator( {
			rpiArea: '.js-reading-wrapper',
			progressBar: {
				show: true,
			},
			percentage: {
				show: false, // default false
				displayBeforeScroll: false, // default false
			},
		} ).init();
	}, 1000 );
}
